export default __webpack_public_path__ + "5827e02b43e6950dc23e76ceab980cda.png";